import PropTypes from 'prop-types'
import React from 'react'

import styles from './Arenas.scss'

const Arenas = (props) => {

    const arenas = props.arenas.map((item, idx) => {
        const tooltipId = `arena-${props.direction}-${idx}-tooltip`

        return (
            <div className={styles.item} key={item.id}>
                <span className={styles.caption} data-tip data-for={tooltipId}>
                    {item.name}
                </span>
            </div>
        )
    })
    return (
        <div className={styles.base}>
            {arenas}
        </div>
    )
}

Arenas.propTypes = {
    arenas: PropTypes.array.isRequired,
    direction: PropTypes.string.isRequired,
}

export default Arenas



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Arenas/Arenas.jsx